module.exports = __webpack_public_path__ + "img/IMG_0300_L_WoodMatted.00291685.jpg";